import Big from "big.js";

export type PurchaseIntentBig = {
	[key in keyof PurchaseIntent]: Big;
};

export type PurchaseIntent = {
	topBox: number;
	secondBox: number;
	top2Box: number;
	score: number;
	sampleSize: number;
};
